import { useState,useEffect } from 'react';
import Image1 from '../Assets/Images/Support/1.png';
import ImageM1 from '../Assets/Images/Support/M1.png';
import {Tick, TickM} from '../Components/Outline';
import AOS from 'aos';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import md5 from 'md5';

const Support = () => {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const {t} = useTranslation();
    const [captcha, setCaptcha] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const [captchaError, setCaptchaError] = useState(false);

    const generateCaptcha = () => {
        const random = Math.floor(100000 + Math.random() * 900000); // 6 digit
        setCaptcha(random.toString());
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (captchaInput !== captcha) {
            setCaptchaError(true);
            generateCaptcha(); // regenerate
            return;
        }

        try {
            const uuid = '43e49695-424d-4f84-a31c-f87f0a9c3232';
            const secret = 'hF26YgpF7zuyp29SbxpRdO8BDLcGrkqElxo2Yz4f';

            const hash = md5(uuid + secret);
            
            await axios.post("https://mail-services.testflight4u.com/api/send-email", {
                sender: { name: formData.name, email: formData.email },
                to: [{ email: "marketing@currenttech.pro", name: "Current Tech Industries" }], // Replace with the recipient email
                subject: `Support Request from ${formData.name}`,
                htmlContent: `<p><strong>Message:</strong> ${formData.message}</p>`,
                method: 'api',
                uuid: uuid,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": hash,
                },
            });
            
            setIsSubmitted(true);
            setFormData({ name: "", email: "", message: "" });
            generateCaptcha(); // new captcha after success
            setCaptchaInput("");

            setTimeout(() => setIsSubmitted(false), 7000);
        } catch (error) {
            console.error('Error sending email:', error);
            alert('Failed to send message. Please try again later.');
            generateCaptcha();
        }
    };

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 200,
        })
    })

    return(
        <div className="pt-[50px] xl:pt-[80px] relative">
            {/* Background Image */}
            <div className="relative">
                <img src={Image1} alt="" className="hidden xl:block w-full object-cover" />
                <img src={ImageM1} alt="" className="xl:hidden w-full object-cover" />
            </div>

            {/* Centered Content */}
            <div className="absolute inset-0 md:top-[-160px] flex flex-col justify-center xl:items-start gap-[50px] pt-[50px] px-[25px] xl:pt-40 xl:pr-0 xl:pl-[163px]">
                {/* Heading */}
                <div className="flex flex-col gap-[10px]">
                    <div className="text-sm md:text-2xl text-[#D1D5DB] font-normal leading-normal w-[266px] md:w-full xl:w-full" data-aos="fade-up">
                        {t("Support.inquiry")}
                    </div>
                    <div className="text-2xl md:text-5xl text-[#D1D5DB] font-light leading-normal " data-aos="fade-up" data-aos-delay="200">
                        <div className='hidden xl:block leading-normal'>{t("Support.hesitation")} <div>{t("Support.hesitation2C")} </div></div>
                        <div className='xl:hidden leading-normal'>{t("Support.hesitationMobile")} </div>
                        <div className='xl:hidden leading-normal'>{t("Support.hesitationMobile2")} </div>
                    </div>
                </div>

                {/* Conditional Rendering: Form or Success Message */}
                {isSubmitted ? (
                    <div className="flex flex-col gap-[100px] text-center">
                        {/* Success Message */}
                        <div className="flex items-center gap-[30px] md:gap-[70px] rounded-[10px] bg-white opacity-80 py-[36px] md:py-[40px] px-[38px] md:px-[50px] md:w-[600px]">
                            <div data-aos="fade-up">
                                <div className='hidden md:block'>
                                    <Tick />
                                </div>
                                <div className='md:hidden'>
                                    <TickM />
                                </div>
                            </div>
                            {/* Web */}
                            <div className="hidden md:block text-xl text-left text-[#4B5563] font-normal" data-aos="fade-up" data-aos-delay="200">
                                <div>{t("Support.messageSuccessfully")}</div>
                                <div>{t("Support.sendToUs")}</div>
                            </div>
                            {/* Mobile */}
                            <div className="md:hidden text-base text-left md:text-xl text-[#4B5563] font-normal" data-aos="fade-up" data-aos-delay="200">
                                <div>{t("Support.messageSuccessfullyMobile")}</div>
                            </div>
                        </div>

                        {/* Bottom Message */}
                        {/* Web */}
                        <div className="hidden md:flex flex-col gap-8 text-xl text-left text-[#D1D5DB] font-normal">
                            <div data-aos="fade-up" data-aos-delay="400">
                                <div>{t("Support.yourMessage")}</div>
                                <div>{t("Support.ourCustomerService")}</div>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="600">
                                {t("Support.thankYou")}
                            </div>
                        </div>
                        {/* Mobile */}
                        <div className="md:hidden flex flex-col gap-8 text-base text-left text-[#D1D5DB] font-normal">
                            <div data-aos="fade-up" data-aos-delay="400">
                                <div>{t("Support.yourMessageMobile")}</div>
                                <div> {t("Support.ourCustomerServiceMobile")}</div>
                                <div>{t("Support.ourCustomerServiceMobile2")}</div>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="600">
                                {t("Support.thankYou")}
                            </div>
                        </div>
                    </div>
                ) : (
                    // Form
                    <form
                        onSubmit={handleFormSubmit}
                        className="flex flex-col gap-[30px] md:gap-[50px] bg-[#E5E7EB] bg-opacity-80 md:bg-opacity-100 px-10 pt-[50px] pb-[30px] md:p-[50px] rounded-[10px] w-full max-w-[600px]"
                        data-aos="fade-up"
                        data-aos-delay="400"
                    >
                        {/* Input Fields */}
                        <div className="flex flex-col gap-[30px] md:gap-[50px]">
                            <input
                                type="text"
                                name="name"
                                placeholder={t('Support.name')}
                                value={formData.name}
                                onChange={handleInputChange}
                                className="w-full py-2 px-5 md:p-3 bg-[#E5E7EB] bg-opacity-0 border border-[#9CA3AF] rounded focus:outline-none"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder={t('Support.email')}
                                value={formData.email}
                                onChange={handleInputChange}
                                className="w-full py-2 px-5 md:p-3 bg-[#E5E7EB] bg-opacity-0 border border-[#9CA3AF] rounded focus:outline-none"
                                required
                            />
                            <textarea
                                name="message"
                                placeholder={t('Support.message')}
                                rows="4"
                                value={formData.message}
                                onChange={handleInputChange}
                                className="w-full py-2 px-5 md:p-3 bg-[#E5E7EB] bg-opacity-0 border border-[#9CA3AF] rounded focus:outline-none"
                                required
                            />
                            <div className="flex flex-col gap-2">
                                <div className="flex flex-col md:flex-row items-center gap-3">
                                    <div
                                        className="px-6 py-3 bg-gray-200 rounded select-none relative overflow-hidden"
                                        style={{
                                            fontSize: "32px",
                                            fontWeight: "bold",
                                            letterSpacing: "10px",
                                            transform: "rotate(0deg)",
                                            textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                                        }}
                                    >
                                        {captcha.split("").map((char, index) => (
                                            <span
                                                key={index}
                                                style={{
                                                    display: "inline-block",
                                                    transform: `rotate(${Math.random() * 40 - 10}deg) `,
                                                }}
                                            >
                                                {char}
                                            </span>
                                        ))}
                                        <div className="absolute inset-0 pointer-events-none">
                                            <div className="w-full h-full bg-[repeating-linear-gradient(45deg,#ccc,#ccc_2px,#eee_2px,#eee_4px)] opacity-30"></div>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={generateCaptcha}
                                        className="text-base font-bold text-blue-500"
                                    >
                                        {t("Support.refresh")}
                                    </button>
                                </div>

                                <input
                                    type="number"
                                    placeholder={t('Support.captcha_placeholder')}
                                    value={captchaInput}
                                    onChange={(e) => {
                                        setCaptchaInput(e.target.value);
                                        setCaptchaError(false);
                                    }}
                                    onPaste={(e) => e.preventDefault()}
                                    className={`w-full py-2 px-5 md:p-3 bg-[#E5E7EB] bg-opacity-0 border border-[#9CA3AF] rounded focus:outline-none ${
                                        captchaError ? "border-red-500" : "border-gray-300"
                                    }`}
                                />

                                {captchaError && (
                                    <span className="text-red-500 text-sm">
                                        {t("Support.invalid_captcha")}
                                    </span>
                                )}
                            </div>

                        </div>

                        {/* Submit Button */}
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="text-base md:text-xl text-[#4B5563] font-normal shadow-custom px-6 xl:px-5 py-2 xl:py-[5px] rounded-[5px] bg-[linear-gradient(180deg,#EAF3FF_0%,#BBD7FE_72%)]"
                            >
                                {t("Support.send")}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>

    )
}

export default Support;